import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import usePrevious from 'lib/src/hooks/usePrevious';

import { revokeSuperAdminMfa } from '@actions/superAdminUsers';
import {
    getSuperAdminUserIsPosting,
    getSuperAdminUserPostSuccess,
    getSuperAdminUsersPostError,
} from '@selectors/superAdminUsers';
import { useHistory } from 'react-router-dom';

import { SuperAdminUser } from 'src/types/shared/SuperAdminUser';

export default function useRevokeSuperAdminMfa({ id }: SuperAdminUser) {
    const dispatch = useDispatch();
    const history = useHistory();

    const closeModal = useCallback(() => {
        history.replace(`/superadmins/${id}`);
    }, [history, id]);

    const handleSubmit = useCallback(() => {
        dispatch(revokeSuperAdminMfa(id));
    }, [dispatch, id]);

    const isPosting = useSelector(getSuperAdminUserIsPosting);
    const error = useSelector(getSuperAdminUsersPostError);
    const postSuccess = useSelector(getSuperAdminUserPostSuccess);
    const prevPostSuccess = usePrevious(postSuccess);

    useEffect(() => {
        if (!prevPostSuccess && postSuccess) {
            closeModal();
        }
    }, [postSuccess, prevPostSuccess, closeModal]);

    return {
        handleSubmit,
        closeModal,
        isPosting,
        error,
    };
}
